/**
 * Versioni
 * 1001 2022/03/05  gestione moveable e resizable
 * 1002 2022/05/04  gestione align
 * 1003 2022/05/07  gestione animazione opzionale
 * 1004 2022/05/27  gestione eventi visualizzazione
 * 1005 2022/06/04  gestione posizione center con align
 * 1006 2023/01/21  dimensioni iniziali (utile per resizable)
 * 1007 2023/11/07  posizione iniziale (anchor 'window')
 */


import {
  LitElement,
  html,
  TemplateResult,
  css,
  PropertyValues
} from 'lit';

import {customElement, property, query} from 'lit/decorators';
import { classMap } from 'lit/directives/class-map';

/**
 * @customElement 'k-overlay'
 */
@customElement('k-overlay')
export class KelydraOverlay extends LitElement {

  public static toggleAnchored(event:MouseEvent, overlayId?:string):void {
    let targetElement:HTMLElement = event.target as HTMLElement;
    if (!overlayId) {
      overlayId = targetElement.getAttribute('data-overlay-id');
      if (!overlayId) {
        console.warn("Missing data-overlay-id attribute");
      }
    }

    let overlay = (<any>targetElement.getRootNode()).getElementById(overlayId);
    if (overlay) {
      (overlay as KelydraOverlay).toggle();
    }
  }

  static styles = css`

    :host {
      --radius: 4px;
      position: fixed;
      top: 0px;
      left: 0px;
      display: none;
      z-index: 999;
    }
    
    .backdrop {
      position: fixed;
      top: 0px;
      left: 0px;
      bottom: 0px;
      right: 0px;
      background: darkgray;
      opacity: 0.8;
    }

    .hidden {
      display: none;
    }
    
    .overlay {
      position: fixed;
      border: 1px solid gray;
    }

    .overlay {
      padding: var(--radius);
      border: 1px solid #aaa;
      border-radius: var(--radius);
      background: var(--overlay-background, white);
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    }

    .arrow.popover--top  {
      margin-top: -16px;
    }

    .arrow.popover--top::before, .arrow.popover--top::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -8px;
      border: 8px solid transparent;
      border-top-color: white;
    }

    .arrow.popover--top::before {
      margin-top: 1px;
      border-top-color: #6a6a6a;
    }

    .arrow.popover--right {
      margin-left: 16px;
    }

    .arrow.popover--right::before, .arrow.popover--right::after {
      content: "";
      position: absolute;
      top: 50%;
      right: 100%;
      margin-top: -8px;
      border: 8px solid transparent;
      border-right-color: white;
    }

    .arrow.popover--right::before {
      margin-right: 1px;
      border-right-color: #6a6a6a;
    }

    .arrow.popover--bottom {
      margin-top: 16px;
    }

    .arrow.popover--bottom::before, .arrow.popover--bottom::after {
      content: "";
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-left: -8px;
      border: 8px solid transparent;
      border-bottom-color: white;
    }

    .arrow.popover--bottom::before {
      margin-bottom: 1px;
      border-bottom-color: #6a6a6a;
    }

    .arrow.popover--left {
      margin-left: -16px;
    }

    .arrow.popover--left::before, .arrow.popover--left::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 100%;
      margin-top: -8px;
      border: 8px solid transparent;
      border-left-color: white;
    }

    .arrow.popover--left::before {
      margin-left: 1px;
      border-left-color: #6a6a6a;
    }

    .arrow.popover--top.arrow.popover-align--start::before, .arrow.popover--top.arrow.popover-align--start::after,
    .arrow.popover--bottom.arrow.popover-align--start::before, .arrow.popover--bottom.arrow.popover-align--start::after {
      left: 16px;
    }

    .arrow.popover--top.arrow.popover-align--end::before, .arrow.popover--top.arrow.popover-align--end::after,
    .arrow.popover--bottom.arrow.popover-align--end::before, .arrow.popover--bottom.arrow.popover-align--end::after {
      left: calc(100% - 16px);
    }

    .arrow.popover--left.arrow.popover-align--start::before, .arrow.popover--left.arrow.popover-align--start::after,
    .arrow.popover--right.arrow.popover-align--start::before, .arrow.popover--right.arrow.popover-align--start::after {
      top: 16px;
    }

    .arrow.popover--left.arrow.popover-align--end::before, .arrow.popover--left.arrow.popover-align--end::after,
    .arrow.popover--right.arrow.popover-align--end::before, .arrow.popover--right.arrow.popover-align--end::after {
      top: calc(100% - 16px);
    }


    .move-handle {
      position:absolute;
      height:var(--move-handle-height, 24px);
      cursor:move;
      left:var(--move-handle-left, 0px);
      right:var(--move-handle-right, 0px);
    }

    .resize-handle {
      height:var(--resize-handle-size, 24px);
      width:var(--resize-handle-size, 24px);
      cursor:nwse-resize;
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAHdJREFUeJzt1jEOgCAMBdDe/9Dq5uAgMdiU6nsJEwv8ob8RAAAAAP3sl/M7AggBnGcrfgvA60ZT/vMtIIAQwG3P2wOA1manfPsWEEAIYKrn7QHA0rKn/PItIIAQQGrP2wOAUtVTvrwFqj8ogMF9uuqetwcAAACPHVyC7wKLG0tpAAAAAElFTkSuQmCC");
      background-size:var(--resize-handle-size, 24px);
      background-repeat: no-repeat;
      position:absolute;
      opacity:0.8;
      right:0px;
      bottom:0px;
    }

    .animated.popover--top {
      animation: .4s slide-top;
    }

    .animated.popover--right {
      animation: .4s slide-right;
    }
    
    .animated.popover--bottom {
      animation: .4s slide-bottom;
    }

    .animated.popover--left {
      animation: .4s slide-left;
    }

    .animated.opacity {
      animation: 1s opacity;
    }


    @keyframes slide-top {
      0% {
        opacity: 0;
        transform: translateY(-15%);
      }

      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes slide-right {
      0% {
        opacity: 0;
        transform: translateX(15%);
      }

      100% {
        opacity: 1;
        transform: translateX(0);
      }
    }

    @keyframes slide-bottom {
      0% {
        opacity: 0;
        transform: translateY(15%);
      }

      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes slide-left {
      0% {
        opacity: 0;
        transform: translateX(-15%);
      }

      100% {
        opacity: 1;
        transform: translateX(0);
      }
    }

    @keyframes opacity {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }

    
  `;


  @property()
  anchor:string;

  @property()
  position:'top' | 'right' | 'bottom' | 'left' | 'center' | 'custom' = 'top';

  @property()
  align:'start' | 'center' | 'end' = 'center'

  @property()
  arrow:'arrow' | undefined;

  @property()
  animated:'animated' | 'opacity' | undefined = 'animated'; 

  @property()
  backdrop:'backdrop' | 'none' = 'none';

  @property()
  autoclose:  'none' | 'backdrop' | 'autoclose' = 'autoclose';

  @property()
  autoshow:'auto' | 'anchor' | 'tooltip' | 'none' | 'delay' = 'none';

  @property()
  moveable:'moveable' | 'none' = 'none'

  @property()
  resizable:'resizable' | 'none' = 'none'

  @property()
  initialWidth:string;

  @property()
  initialHeight:string;

  @property()
  initialTop:string;

  @property()
  initialLeft:string;


  @query('.overlay')
  overlayElement:HTMLDivElement

  @query('.backdrop')
  backdropElement:HTMLDivElement

  @query('.move-handle')
  moveHandleElement:HTMLDivElement

  @query('.resize-handle')
  resizeHandleElement:HTMLDivElement

  anchorElement:HTMLElement;

  handleWindowEvent: Function;
  handleDocumentEvent: Function;
  handleAnchorClick:Function;
  handleAnchorEnter:Function;
  handleAnchorLeave:Function;


  constructor() {
    super();
    this.handleWindowEvent = () => {
      if (this.visible) {
        this.show();
      }
    };

    this.handleDocumentEvent = (evt:MouseEvent) => {
      let clickedContent:boolean = false;
      let clickedBackdrop:boolean = false;
      let clickedThis:boolean = false;
      
      //Verifico che non sia inviato da un elemento dello slot
      try {
        if (this.shadowRoot.contains(<any>evt.composedPath()[0]) || this.contains(<any>evt.composedPath()[0])) {
        }
        if (!clickedContent) {
          evt.composedPath().forEach(pathElement => {
            if (pathElement == this) {
              clickedContent = true;
            }
          })
        }
      } catch {}


      if (evt.target == this.backdropElement) {
        clickedBackdrop = true;
      }

      if (evt.target == this) {
        clickedThis = true;
      }

      if (this.visible && evt.target !== this.anchorElement) {
        if ((this.autoclose === "autoclose")
        || (this.autoclose === "backdrop" && clickedBackdrop)
        || (this.autoclose === "backdrop" && (!clickedContent && !clickedThis))) {
            this.hide();
        }
      }
    };

  }

  public get visible() {
    return this.style.display == 'inline-block'
  }

  protected isInViewport(element:HTMLElement) {
    const rect = element.getBoundingClientRect();
    const html = document.documentElement;
    return rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || html.clientHeight) &&
      rect.right <= (window.innerWidth || html.clientWidth);
  }

  protected forceInViewport(element:HTMLElement):{deltaX:number, deltaY:number} {
    const rect = element.getBoundingClientRect();
    const html = document.documentElement;
    let result = {deltaX:0, deltaY:0};
    let moved = false;
    if (rect.left < 0) {
      result.deltaX = -rect.left;
    }
    if (rect.top < 0) {
      result.deltaY = -rect.top;
    }

    if (rect.bottom > html.clientHeight) {
      result.deltaY =  html.clientHeight - rect.bottom;
    }

    if (rect.right > html.clientWidth) {
      result.deltaX = html.clientWidth - rect.right;
    }

    if (result.deltaX || result.deltaY) {
      return result;
    }
    return undefined;
  }



  public toggle(options:IOverlayShowOptions = {}):void {
    if (this.visible) {
      this.hide();
    } else {
      this.show(options);
    }
  }

  public show(options:IOverlayShowOptions = {}):void {
    this.style.visibility = 'hidden';
    this.style.display = 'inline-block';

    this.style.top = "0px";
    this.style.left = "0px";

    let className = 'popover';




    this.anchorElement = null;
    const anchor = options.anchor || this.anchor;
    if (anchor) {
      this.anchorElement = (<any>this.getRootNode()).getElementById(anchor);
    }

    const anchorElement = options.anchorElement || this.anchorElement

    const backdrop = options.backdrop || this.backdrop;

    const html = document.documentElement;


    const { top: triggerTop, left: triggerLeft } = anchor != 'window' ? anchorElement.getBoundingClientRect() : {top:0, left:0};
    const { offsetHeight: triggerHeight, offsetWidth: triggerWidth } = anchor != 'window' ? anchorElement : {offsetHeight :window.innerHeight || html.clientHeight, offsetWidth:window.innerWidth || html.clientWidth};
    let { offsetHeight: popoverHeight, offsetWidth: popoverWidth } = this.overlayElement;

    let positionParameter:any = (anchor != 'window') ? options.position || this.position : (options.position || (this.position != 'top' ? this.position : 'center'));
    let alignParameter:string = this.align;

    if (options.showAsPopup) {
      if (popoverWidth < triggerWidth) {
        popoverWidth = triggerWidth;
        this.overlayElement.style.width = triggerWidth +'px';
        options.position = 'bottom';
      }
    }


    let position:{top:number;left:number} = null;

    switch(positionParameter) {
      case 'top':
        position = {
          top: triggerTop - popoverHeight,
          left: alignParameter == 'center' ? triggerLeft - ((popoverWidth - triggerWidth) / 2) : (alignParameter == 'start' ? triggerLeft : triggerLeft + triggerWidth - popoverWidth),
        };
        
        break;
      case  'right': 
        position = {
          top: alignParameter == 'center' ? triggerTop - ((popoverHeight - triggerHeight) / 2) : (alignParameter == 'start' ? triggerTop : triggerTop + triggerHeight - popoverHeight),
          left: triggerLeft + triggerWidth
        };
        break;
      case  'bottom': 
        position = {
          top: triggerTop + triggerHeight,
          left: alignParameter == 'center' ? triggerLeft - ((popoverWidth - triggerWidth) / 2) : (alignParameter == 'start' ? triggerLeft : triggerLeft + triggerWidth - popoverWidth),
        };
        break;
      case  'left': 
        position = {
          top: alignParameter == 'center' ? triggerTop - ((popoverHeight - triggerHeight) / 2) : (alignParameter == 'start' ? triggerTop : triggerTop + triggerHeight - popoverHeight),
          left: triggerLeft - popoverWidth
        };
        break;
      case  'center': 
        position = {
          top: alignParameter == 'center' ? triggerTop - ((popoverHeight - triggerHeight) / 2) : (alignParameter == 'start' ? triggerTop : triggerTop + triggerHeight - popoverHeight),
          left:alignParameter == 'center' ?  triggerLeft - ((popoverWidth - triggerWidth) / 2) : (alignParameter == 'start' ? triggerLeft : triggerLeft + triggerWidth - popoverWidth),
        };
        break;
  
    }


    if (position) {
      this.overlayElement.style.top = position.top+'px';
      this.overlayElement.style.left = position.left+'px';
    }

    this.overlayElement.classList.remove(className + "--top");
    this.overlayElement.classList.remove(className + "--right");
    this.overlayElement.classList.remove(className + "--bottom");
    this.overlayElement.classList.remove(className + "--left");

    this.overlayElement.classList.remove(className + "-align--start");
    this.overlayElement.classList.remove(className + "-align--center");
    this.overlayElement.classList.remove(className + "-align--end");


    this.overlayElement.classList.add(className + "--" + positionParameter);
    this.overlayElement.classList.add(className + "-align--" + alignParameter);

    if (backdrop == 'backdrop') {
      this.backdropElement.style.display = '';
    }

    let delta = this.forceInViewport(this.overlayElement);
    if (delta) {
      this.overlayElement.style.top = (position.top + delta.deltaY)+'px';
      this.overlayElement.style.left = (position.left + delta.deltaX)+'px';
    }

    this.style.visibility = 'visible';

    let showEvent = new CustomEvent('show',{});
    this.dispatchEvent(showEvent);



    if (this.autoclose === "autoclose" || (this.autoclose === "backdrop" && backdrop !== "backdrop")) {
      setTimeout(() => {
        if (this.visible) {
          document.addEventListener('click', <any>this.handleDocumentEvent);
          window.addEventListener('scroll', <any>this.handleWindowEvent);
          window.addEventListener('resize', <any>this.handleWindowEvent);
        }
      },300);
    }

  }

  public hide():void {
    this.style.display = '';

    this.backdropElement.style.display = 'none';

    let hideEvent = new CustomEvent('hide',{});
    this.dispatchEvent(hideEvent);

    document.removeEventListener('click', <any>this.handleDocumentEvent);
    window.removeEventListener('scroll', <any>this.handleWindowEvent);
    window.removeEventListener('resize', <any>this.handleWindowEvent);

  }


  protected onBackdropClick() {
    if (this.autoclose  === "autoclose" || this.autoclose === "backdrop") {
      this.hide();
    }
  }


  protected firstUpdated(_changedProperties: PropertyValues) {
    //this.overlayElement = this.shadowRoot.querySelector('.overlay');
    //this.backdropElement = this.shadowRoot.querySelector('.backdrop');

    if (this.autoshow === "auto") {
      this.show();
    } else if (this.autoshow === "delay") {
      window.setTimeout(() => {
        this.show();
      },100);
    } else if ((this.autoshow === "anchor" || this.autoshow === "tooltip") && this.anchor) {
      let anchorElement = (this.getRootNode() as HTMLElement).querySelector('#'+this.anchor);
      if (anchorElement) {
        if (this.autoshow === "anchor") {
          this.handleAnchorClick = (evt:MouseEvent) => {
            this.show()
          };
          anchorElement.addEventListener('click',<any>this.handleAnchorClick);
        } else if (this.autoshow === "tooltip") {
          this.handleAnchorEnter = (evt:MouseEvent) => {
            this.show()
          };
          this.handleAnchorLeave = (evt:MouseEvent) => {
            this.hide();
          };
          anchorElement.addEventListener('mouseenter',<any>this.handleAnchorEnter);
          anchorElement.addEventListener('mouseleave',<any>this.handleAnchorLeave);

        }
      }


    }

    if (this.moveable === 'moveable') {
      this.makeMoveable();
    }

    if (this.resizable === 'resizable') {
      this.makeResizable();
    }

    if (this.initialWidth) {
      this.overlayElement.style.width = this.initialWidth;
    }
    if (this.initialHeight) {
      this.overlayElement.style.height = this.initialHeight;
    }

    if (this.initialTop) {
      this.overlayElement.style.top = this.initialTop;
    }

    if (this.initialLeft) {
      this.overlayElement.style.left = this.initialLeft;
    }

  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.handleAnchorClick) {
      let anchorElement = (this.getRootNode() as HTMLElement).querySelector('#'+this.anchor);
      if (anchorElement) {
        anchorElement.removeEventListener('click',<any>this.handleAnchorClick);
        anchorElement.removeEventListener('mouseenter',<any>this.handleAnchorEnter);
        anchorElement.removeEventListener('mouseleave',<any>this.handleAnchorLeave);
      }
    }
  }

  makeMoveable() {
    let startPosition = {offsetTop:0, offsetLeft:0};
    let startMouse = {clientX:0, clientY:0};

    let dragMouseDown = (e:MouseEvent) => {
      e.preventDefault();

      startPosition = {offsetTop:this.overlayElement.offsetTop, offsetLeft:this.overlayElement.offsetLeft};
      startMouse ={clientX:e.clientX, clientY:e.clientY};
      document.addEventListener('mouseup', closeDragElement);
      document.addEventListener('mousemove', elementDrag);
    }

    let elementDrag = (e:MouseEvent) => {
      e.preventDefault();
      // set the element's new position:

      let deltaX = e.clientX - startMouse.clientX;
      let deltaY = e.clientY - startMouse.clientY;

      this.overlayElement.style.top = (startPosition.offsetTop + deltaY) + 'px';
      this.overlayElement.style.left = (startPosition.offsetLeft + deltaX) + 'px';

    }


    let closeDragElement = () => {
      document.removeEventListener('mouseup', closeDragElement);
      document.removeEventListener('mousemove', elementDrag);
    }

    this.moveHandleElement.onmousedown = dragMouseDown;
  
  
  
  }

  makeResizable() {
    let startSize = {width:0, height:0};
    let startMouse = {clientX:0, clientY:0};

    let dragMouseDown = (e:MouseEvent) => {
      e.preventDefault();

      startSize = {width:this.overlayElement.clientWidth, height:this.overlayElement.clientHeight};
      startMouse ={clientX:e.clientX, clientY:e.clientY};
      document.addEventListener('mouseup', closeDragElement);
      document.addEventListener('mousemove', elementDrag);
    }

    let elementDrag = (e:MouseEvent) => {
      e.preventDefault();
      // set the element's new position:

      let deltaX = e.clientX - startMouse.clientX;
      let deltaY = e.clientY - startMouse.clientY;

      this.overlayElement.style.width = (startSize.width + deltaX) + 'px';
      this.overlayElement.style.height = (startSize.height + deltaY) + 'px';

    }


    let closeDragElement = () => {
      document.removeEventListener('mouseup', closeDragElement);
      document.removeEventListener('mousemove', elementDrag);
    }

    this.resizeHandleElement.onmousedown = dragMouseDown;
  
  
  
  }



  render(): TemplateResult {
    return html`
        <host>
            <div class="backdrop hidden" @click=${this.onBackdropClick}></div>
            <div class="overlay ${classMap({animated:this.animated, opacity:this.animated == 'opacity' , arrow:this.arrow})}">
            ${this.moveable === 'moveable' ? html`<div class="move-handle"></div>` : null}
            <slot></slot>
            ${this.resizable === 'resizable' ? html`<div class="resize-handle"></div>` : null}
            </div>
        </host>
    `;
  }
}

export interface IOverlayShowOptions {
  position?:string;
  anchor?:string;
  anchorElement?:HTMLElement;
  backdrop?:string;
  showAsPopup?:boolean;
}
